import type { routes } from '@semios/app-platform-banyan-route-definitions'
import {
  getValueTypeFromEmitterType,
  IRRIGATION_ACTIVITY_APPLIED_VALUE_TYPE_PREFIX,
  IRRIGATION_ACTIVITY_PLANNED_VALUE_TYPE_PREFIX,
} from '@semios/app-platform-values-helpers-and-types'
import { getIdAndEmitterTypeFromZoneEmitterTypeKey } from 'App/Map/_utils/irrigationZoneEmitterTypeKeyUtil'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TIrrigationZoneEmitterId } from 'stores/fieldAssetStore/helperTypes'
import type { TSelectedFieldAssetsStoreState } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import type { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'

export const getIrrigationZoneArgs = ({
  selectedValueGroups,
  selectedFieldAssets,
  irrigationZoneIds,
}: {
  selectedValueGroups: ReturnType<typeof selectedValueGroupsStore.getState>['selectedValueGroups']
  selectedFieldAssets: TSelectedFieldAssetsStoreState
  irrigationZoneIds: number[]
}): Partial<routes.Values.Request> => {
  if (!selectedValueGroups.irrigation_activity_pressure || !selectedFieldAssets.irrigationZoneEmitter)
    return {}

  const preferredAggregationInterval = {
    preferredAggregationInterval: 'UNAGGREGATED',
  }

  const properties = fieldAssetStore.getState().properties
  const propertyId = selectedFieldAssets.property
  const property = propertyId ? (properties ?? {})[propertyId] : null

  const emittersForZone = irrigationZoneIds.flatMap((zoneId) =>
    Object.keys(property?.irrigationZoneEmitters ?? {})
      .filter((key) => key.startsWith(zoneId.toString()))
      .map((key) => getIdAndEmitterTypeFromZoneEmitterTypeKey(key as TIrrigationZoneEmitterId).emitterType),
  )

  const valuesRequestedForIrrigationZones: Record<string, typeof preferredAggregationInterval> = {}

  const valueTypesForSemiosIntervals = emittersForZone.map((emitter) => {
    return getValueTypeFromEmitterType(IRRIGATION_ACTIVITY_APPLIED_VALUE_TYPE_PREFIX, emitter)
  })

  const valueTypesForPlannedSemiosIntervals = emittersForZone.map((emitter) => {
    return getValueTypeFromEmitterType(IRRIGATION_ACTIVITY_PLANNED_VALUE_TYPE_PREFIX, emitter)
  })

  valueTypesForSemiosIntervals.forEach((valueType) => {
    valuesRequestedForIrrigationZones[valueType] = preferredAggregationInterval
  })

  valueTypesForPlannedSemiosIntervals.forEach((valueType) => {
    valuesRequestedForIrrigationZones[valueType] = preferredAggregationInterval
  })

  return {
    irrigationZones: {
      irrigationZoneIds,
      valuesRequested: valuesRequestedForIrrigationZones,
    },
  }
}
